import * as server from "@/utils/http"

export const _page = params => server.get("/scan-testTube-log/page", params);

